/**
 * setCookie
 *
 * Sets a cookie with the specified name and value.
 *
 * @param {string} name - The name of the cookie to set.
 * @param {string} value - The value to set for the cookie.
 * @param {number} [days] - Optional. The number of days until the cookie
 *                          expires. If not specified, the cookie will expire
 *                          when the user closes the browser.
 * @returns {void}
 */
export function setCookie(name, value, days) {
    let expires = "";
    if (days) {
        const date = new Date();
        date.setTime(date.getTime() + days * 24 * 60 * 60 * 1000);
        expires = "; expires=" + date.toUTCString();
    }
    document.cookie = name + "=" + value + expires + "; path=/";
}
